import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  public handleCloseEmitter: EventEmitter<boolean> = new EventEmitter();

  public handleClose(): void {
    this.handleCloseEmitter.emit(true);
  }
}
